<div class="test-completed" *ngIf="payloadData$ | async as data">
    <div class="pcr-item pcr-item--padding">
        <gen-button class="downloadButton" [type]="'primary'" [iconClass]="'arrow-icon'" [text]="'Download Report'" (click)="downloadPdf($event)">
        </gen-button>
        <!--<div class="btn btn-primary downloadButton">-->
        <!--<img [src]="arrowImgPath" class="arrow-icon">-->
        <!--<span class="DownloadText">Download</span>-->
        <!--</div>-->
        <div class="results-info">
            <div class="results-title">Quality indicators</div>
            <gen-info-box class="results-quality-indicator" [message]="getQcMessage(data)" [iconType]="getQcIconType(data)" [backgroundCss]="'__themed-background'" [borderCss]="'__border'">
            </gen-info-box>
            <ng-container *ngIf="tumorWarning">
                <gen-info-box class="results-quality-indicator" [message]="'Tumor percentage below specification'" [iconType]="'info'" [borderCss]="'__border'" [backgroundCss]="'__themed-background'">
                </gen-info-box>
            </ng-container>
        </div>
        <div class="results-info">
            <div class="results-title">Notes</div>
            <div id="note_counter">
                {{getNotes()}} {{getNotes() == 1 ? "Note" : "Notes"}}
            </div>
        </div>
        <gen-info-lines [sourceData]="currentOrder$ | async"
                        [title]="'Sample data'"
                        [fieldsToDisplay]="sampleDataFields"
                        [translationPrefix]="'processing'"
        >
        </gen-info-lines>
    </div>
    <div class="pcr-item pcr_container">
        <label class="results-title">Analysis results</label>
        <ng-container *ngIf="isQcPassed(data); else qc_failed">
            <article class="pcr_article">
                <label class="analysis-title-desc" translate>{{disclaimerMsg}}</label>
                <gen-ruler-graph class="ruler-graph" [pathwayWithComment]="getGeneComment(model)" [model]="model" *ngFor="let model of getResult(data)"></gen-ruler-graph>
                <div class="score-container">
                    <div class="activity-score">0</div>
                    <div class="activity-score">20</div>
                    <div class="activity-score">40</div>
                    <div class="activity-score">60</div>
                    <div class="activity-score">80</div>
                    <div class="activity-score">100</div>
                </div>
                <div class="activity-score-container">
                    <div class="activity-score-bar">
                        <div class="score-range__edge__gray"></div>
                        <div class="activity-vertical-line"></div>
                        <label class="activity-score-label">Activity Score</label>
                        <div class="activity-vertical-line"></div>
                        <div class="score-range__edge__gray"></div>
                    </div>
                    <div class="liner-gradient-buttom-container">
                        <div class="score-range">
                            <div class="score-range__edge"></div>
                            <div class="score-range__line"></div>
                            <div class="score-range__edge"></div>
                        </div>
                        <div class="liner-gradient-score-text">95% confidence interval</div>
                    </div>
                    <div class="disclaimers">
                    	<ng-container *ngFor="let pathwayWithComment of pathwaysWithComment$|async">
                            <ng-container *ngIf="pathwayWithComment && isPathwayCommentExist(pathwayWithComment.gene)">
                                <div class="flex-container" [ngClass]="pathwayWithComment.class ? pathwayWithComment.class : ''">
                                    <ng-container *ngIf="pathwayWithComment.label">
                                        <label [ngClass]="pathwayWithComment.label.class? pathwayWithComment.label.class: ''">{{pathwayWithComment.label.content ? pathwayWithComment.label.content : ''}}</label>
                                    </ng-container>
                                    <ng-container *ngIf="pathwayWithComment.comment">
                                        <div [ngClass]="pathwayWithComment.comment.class?pathwayWithComment.comment.class:''" [innerHTML]="pathwayWithComment.comment.content?pathwayWithComment.comment.content:''"></div>
                                    </ng-container>
                                </div>
                            </ng-container>
                    	</ng-container>
                    </div>
                </div>
            </article>
        </ng-container>
        <ng-template #qc_failed>
            <div class="results-info">
            <div>Results couldn't be generated, due to technical QC failed</div>
            <div *ngIf="isQcfailReason(data)">
            <div class="qc-fail-reason results-title">Reason</div>
            <div>{{getQcFailReason(data)}}</div>
        </div>
        </div>
        </ng-template>

    </div>

</div>
